import listSearch from './listSearch'
import getCurrentQuery from '../utils/getCurrentQuery'

export default (query) => (dispatch, getState) => {
  const query = getCurrentQuery()
  dispatch(listSearch(query))
  dispatch({type: 'erase_paths'})
}



/** WEBPACK FOOTER **
 ** ./app/actions/executeQuery.js
 **/